import { render, staticRenderFns } from "./gj-wang-editor.vue?vue&type=template&id=004bd168&scoped=true&"
import script from "./gj-wang-editor.vue?vue&type=script&lang=js&"
export * from "./gj-wang-editor.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./gj-wang-editor.vue?vue&type=style&index=1&id=004bd168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004bd168",
  null
  
)

export default component.exports